import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/business-point-applications', config);
};

const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/business-point-applications/excel-export', {
        ...config,
        responseType: 'blob'
    });
};

const showCv = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/business-point-applications/' + id + '/cv', {
        responseType: 'blob'
    });
};

const remove = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/coop/business-point-applications/' + id);
};

const getAvailableSlots = async (eventId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/business-point-events/' + eventId + '/available-slots');
};

const apply = async (eventId, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/coop/business-point-events/' + eventId + '/apply', data);
};

const getMe = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/coop/business-point-applications/me', config);
};

export default {
    getAll,
    excelExport,
    showCv,
    remove,
    getAvailableSlots,
    apply,
    getMe
};
